import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Grid, Message, Segment } from 'semantic-ui-react'

import LookupProduct from './LookupProduct'
import BatchLookupList from './BatchLookup/BatchLookupList'
import BatchAssignment from './BatchLookup/BatchAssignment'
import BatchFileUpload from './BatchLookup/BatchFileUpload'
import { CustomSegment } from './styles'
import { PATH_BATCH_LOOKUP } from '../../consts'
import { AppState } from '../../redux/store'

interface Props {}

const LookupProductWrapper = (props: Props) => {
  const location = useLocation()
  const isBatchLookup = location.pathname === PATH_BATCH_LOOKUP
  const { batchLookupValues, batchLookupStage, currentBatchId } = useSelector(
    (state: AppState) => state.ui
  )
  const { batchAliasAssignments } = useSelector((state: AppState) => state.productAliases)
  const isBatchAliasAssigned = !!(
    currentBatchId && batchAliasAssignments[currentBatchId]?.isConfirmed
  )
  const isBatchIgnored = !!(currentBatchId && batchAliasAssignments[currentBatchId]?.isIgnored)
  const [modalActive, setModalActive] = useState(false)
  const [preSelectedId, setPreSelectedId] = useState<number | null | undefined>(null)

  return (
    <CustomSegment basic padded>
      {isBatchLookup && batchLookupStage === 'upload' && (
        <Segment padded basic>
          <BatchFileUpload />
        </Segment>
      )}
      {isBatchLookup && ['review', 'create'].includes(batchLookupStage) && (
        <Segment basic>
          <Grid>
            <Grid.Column width={3} style={{ paddingTop: 30 }}>
              <BatchLookupList
                disableArrowKeys={modalActive}
                setPreSelectedId={(id: number | null | undefined) => setPreSelectedId(id)}
              />
            </Grid.Column>
            <Grid.Column width={13}>
              <BatchAssignment
                batchLookupValues={batchLookupValues}
                isBatchAliasAssigned={isBatchAliasAssigned}
              />
              {isBatchIgnored ? null : isBatchAliasAssigned ? (
                <Segment basic>
                  <Message content="Alias saved." />
                </Segment>
              ) : (
                <LookupProduct
                  mode={isBatchLookup ? 'batchLookup' : 'default'}
                  onModalActiveChange={(val: boolean) => setModalActive(val)}
                  preSelectedId={preSelectedId}
                />
              )}
            </Grid.Column>
          </Grid>
        </Segment>
      )}
      {!isBatchLookup && (
        <LookupProduct
          mode={isBatchLookup ? 'batchLookup' : 'default'}
          onModalActiveChange={(val: boolean) => setModalActive(val)}
        />
      )}
    </CustomSegment>
  )
}

export default LookupProductWrapper
